module.exports = __webpack_public_path__ + "static/mentoring-project-rebound-students-d88b4902bdac1f0efa4fc75368aadc1d.jpg";